import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  buyHelper,
  phaseChange,
  reroute,
  storeDumpItForce,
  toggleHelpDocumenti,
} from '../../../actions/Buy'
import {
  bonificoFileUploadDropped,
  bonificoFileUploadRemoved,
  postBonificoFileUpload,
} from '../../../actions/buy/Documenti'
import OrderRecoveryBanner from '../../dumb/OrderRecoveryBanner'
import DocumentiHelper from '../../noleggia/dumb/DocumentiHelper'
import BuyHelpBankDocuments from '../dumb/BuyHelpBankDocuments'
import FileUploadErrorMessage from '../dumb/FileUploadErrorMessage'
import { getBrumbrumColor } from '../utils'

class Documents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasRejectedFiles: false,
    }

    this.onOpenClick = this.onOpenClick.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.removeFile = this.removeFile.bind(this)
    this.handleHelper = this.handleHelper.bind(this)
    this.buildListaDocumentiSelezionatiPerUpload =
      this.buildListaDocumentiSelezionatiPerUpload.bind(this)
    this.state.documenti_necessari = [
      { label: "Documento d'identità (fronte e retro)" },
      { label: 'Codice fiscale (fronte e retro)' },
      { label: 'Modulo Istanza Unificata (ricevuto via email)' },
    ]
    this.state.upload_btn_disabled = true
    this.state.counter = 0
    this.state.toTop = false
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register', true)
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // eslint-disable-next-line
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    // eslint-disable-next-line
    for (const key in nextProps) {
      if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 50 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }
    if (
      this.props.compass_tabelledominio.cittadinanza_is_extra_eu_by_codice[
        this.props.customer.cittadinanza.split('|')[0]
      ]
    ) {
      this.setState({
        documenti_necessari: this.state.documenti_necessari.concat([
          { label: 'Permesso di soggiorno' },
        ]),
      })
    }

    this.props.storeDumpItForce()

    // BRUM-6741 si mostra subito l'help di come far le foto ai documenti
    setTimeout(() => this.props.toggleHelpDocumenti(true), 3000)
  }

  removeFile() {
    const that = this
    return function (e) {
      e.preventDefault()
      e.stopPropagation()
      that.props.bonificoFileUploadRemoved(e.target.id.replace('remove-', ''))
      if (that.props.bonificoFileUpload.dropzone.length === 0) {
        that.setState({ upload_btn_disabled: true })
      }
    }
  }

  onDrop(acceptedFiles, fileRejections) {
    this.setState({ hasRejectedFiles: fileRejections.length > 0 })

    if (this.state.upload_btn_disabled) {
      this.setState({ upload_btn_disabled: acceptedFiles.length <= 0 })
    }

    this.props.bonificoFileUploadDropped({ dropzone: acceptedFiles })
  }

  onOpenClick(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dropzone.open()
  }

  handleCheckbox() {
    const that = this
    return function (event) {
      if (event.target.checked) {
        that.setState({ counter: that.state.counter + 1 })
      } else {
        that.setState({ counter: that.state.counter - 1 })
      }
    }
  }

  handleHelper() {
    this.props.buyHelper()
  }

  handleSubmit() {
    const t = this
    if (!this.props.fetching) {
      // if (this.state.counter <= 0) {
      //   this.setState( { documenti_necessari_error : 'is-required' } )
      // } else if ( this.state.counter !== this.state.documenti_necessari.length ) {
      //   this.setState( { documenti_necessari_error : 'is-error' } )
      // } else {
      //  this.setState( { documenti_necessari_error : '' } )

      if (!this.state.upload_btn_disabled) {
        // check disponibilita' auto
        t.props.reroute().then(() => {
          this.props
            .postBonificoFileUpload({
              dropzone: this.props.bonificoFileUpload.dropzone,
              token: this.props.customer.token,
              id_ordine: this.props.ordine.id_ordine,
            })
            .then(() => {
              t.props.phaseChange({
                last: t.props.ui.last > 50 ? t.props.ui.last : 50,
              })
              t.props.reroute('/thank-you', true)
            })
            .catch(() => null)
        })
      }
      // }
    }
  }

  buildListaDocumentiNecessari() {
    const t = this
    return t.state.documenti_necessari.map((documento, i) => (
      <li key={i}>
        <span className="document_name">
          <label className="r-checkbox">
            <input onChange={this.handleCheckbox} type="checkbox" value="1" />
            {/* <span className="check"></span> */}
            {documento.label}
            <a className="upload-mobile">
              <i className="icon-arrow_double_right"></i>
            </a>
          </label>
        </span>
      </li>
    ))
  }

  buildListaDocumentiSelezionatiPerUpload() {
    const t = this
    return t.props.bonificoFileUpload.dropzone.map((documento, i) => (
      <li key={i}>
        <div className={'file_preview'}>
          <img src={documento.preview} />
        </div>
        <div className={'file_link'}>
          <a
            className={'file_link--label'}
            href={documento.preview}
            rel="noreferrer"
            target="_blank"
          >
            {documento.name}
          </a>
        </div>
        <span className={'file_remove'}>
          <a className="file_remove--link" onClick={this.removeFile()}>
            {' '}
            <i className="icon-close file_remove--icon" id={`remove-${i}`}></i>
          </a>
        </span>
      </li>
    ))
  }

  render() {
    return (
      <div>
        <div className="process__header hide-print">
          <h1 className="process__title hide-print">Carica i tuoi documenti</h1>
          <p className="process__intro hide-print">
            Aiutaci a raccogliere i documenti che servono a completare il
            passaggio di proprietà.
          </p>
        </div>
        <div className={'messages warning'}>
          <div className={'container'}>
            <OrderRecoveryBanner />
          </div>
        </div>
        <div className="user-informations">
          <div className="container--small">
            <BuyHelpBankDocuments
              helper={this.handleHelper}
              show={this.props.help}
            />

            <div className="documents__upload">
              <div className="documents__upload__left">
                <div className="documents_list">
                  <ul>
                    <li className="title">
                      <span className={'only-desktop'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , carica i seguenti documenti:
                      </span>
                      <span className={'only-mobile'}>
                        Ciao{' '}
                        <span className={'user_name'} data-hj-suppress>
                          {this.props.customer.nome}
                        </span>
                        , ci servono questi documenti:
                      </span>
                    </li>

                    {this.state.documenti_necessari.length > 0 &&
                      this.buildListaDocumentiNecessari()}

                    <li className={'files__list hidden-md'}>
                      <ul>
                        {this.props.bonificoFileUpload.dropzone.length > 0 ? (
                          <li className={'title small'}>Documenti caricati:</li>
                        ) : null}
                        {this.props.bonificoFileUpload.dropzone.length > 0 &&
                          this.buildListaDocumentiSelezionatiPerUpload()}
                      </ul>
                    </li>

                    {this.state.hasRejectedFiles && <FileUploadErrorMessage />}

                    {this.props.bonificoFileUpload.dropzone.length > 0 ? (
                      <li className="last">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          data-cy="documents-submit"
                          onClick={this.handleSubmit}
                        >
                          <span>Ho completato l'upload!</span>
                        </a>
                      </li>
                    ) : null}
                  </ul>
                </div>
              </div>
              <div className="documents__upload__right">
                <DocumentiHelper
                  flowType={'buy-bank'}
                  onClick={() => this.props.toggleHelpDocumenti(true)}
                />
                <DropZone
                  accept="application/pdf,image/jpg,image/jpeg,image/png"
                  activeClassName="drag_accept"
                  className="drag_drop"
                  onDrop={this.onDrop}
                  ref={node => {
                    this.dropzone = node
                  }}
                  rejectClassName="drag_reject"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className="drag_drop__content">
                      <input {...getInputProps()} data-cy="documents-file" />
                      <i className="icon-upload"></i>
                      <h2>Trascina qui i tuoi documenti</h2>
                      <span
                        style={{
                          fontSize: '12px',
                          color: getBrumbrumColor().grey600,
                        }}
                      >
                        (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)
                      </span>
                    </div>
                  )}
                </DropZone>
                <div
                  className="documents__upload__other"
                  style={{ marginTop: '15px' }}
                >
                  <span
                    className={'only-desktop'}
                    style={{
                      fontStyle: 'italic',
                      color: getBrumbrumColor().grey600,
                    }}
                  >
                    Oppure
                  </span>
                  <div className="file-upload-box">
                    <div
                      className="fileUpload btn btn-secondary"
                      onClick={this.onOpenClick}
                    >
                      <span className={'only-desktop'}>Scegli un file</span>
                      <span className={'only-mobile'}>
                        Carica/Scatta una foto
                      </span>
                      <input className="upload" id="uploadBtn" type="file" />
                    </div>

                    {this.props.bonificoFileUpload.dropzone.length > 0 && (
                      <div className={'files__list hidden-lg'}>
                        <ul>
                          {this.props.bonificoFileUpload.dropzone.length > 0 ? (
                            <li className={'title small'}>
                              Documenti caricati:
                            </li>
                          ) : null}
                          {this.props.bonificoFileUpload.dropzone.length > 0 &&
                            this.buildListaDocumentiSelezionatiPerUpload()}
                        </ul>
                      </div>
                    )}

                    {this.props.bonificoFileUpload.dropzone.length > 0 ? (
                      <div className="only-mobile">
                        <a
                          className={
                            this.props.fetching ||
                            this.state.upload_btn_disabled
                              ? 'btn btn-primary btn-disabled'
                              : 'btn btn-primary'
                          }
                          onClick={this.handleSubmit}
                        >
                          <span>Ho completato l'upload!</span>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="contacts_list">
              <ul>
                <li className="title">
                  <span>
                    Problemi con l'upload?
                    <br />
                    Chiama il Servizio Clienti allo <b>02.800.29</b>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  bonificoFileUpload: state.bonificoFileUpload,
  compass_tabelledominio: state.compass_tabelledominio,
  customer: state.customer,
  ordine: state.ordine,
  fetching: state.ui.fetching,
  ui: state.ui,
  help: state.ui.buyHelper,
})

export default connect(mapStateToProps, {
  postBonificoFileUpload,
  bonificoFileUploadDropped,
  bonificoFileUploadRemoved,
  phaseChange,
  storeDumpItForce,
  reroute,
  buyHelper,
  toggleHelpDocumenti,
})(Documents)
